import { getBaseUrl } from "@/lib/getBaseURL";

async function collectionLoader<T>(contentType: string,language:string): Promise<T[]> {
  const BaseUrl = getBaseUrl();
  const url = `${BaseUrl}/api/${contentType}?populate=*&pagination[page]=1&pagination[pageSize]=100&locale=${language}`;  const response = await fetch(url, {
    headers: {
      Accept: "application/json",
    },
    cache: 'no-store',
  });
  const json = await response.json();
  return json.data as T[];
}
export { collectionLoader };
